module.exports = __webpack_public_path__ + "img/360-entre.ba5b928a.jpg";